import React from 'react';
import { useSettings } from '../context/SettingsContext';

const Menu = () => {
    const { isModuleActive } = useSettings();
    const waActive = isModuleActive('whatsapp');
    const tgActive = isModuleActive('telegram');

    return (
        <nav className="nxl-navigation">
            <div className="navbar-wrapper">
                <div className="m-header">
                    <a href="index.html" className="b-brand">
                        <img src="./../assets/images/crm-logo.png" alt="CRM Logo" width="100%" className="logo logo-lg" />
                        <img src="./../assets/images/crm-logo-small.png" alt="" className="logo logo-sm" />
                    </a>
                </div>
                <div className="navbar-content">
                    <ul className="nxl-navbar">
                        <li className="nxl-item nxl-caption">
                            <label>Menü</label>
                        </li>
                        <li className="nxl-item">
                            <a href="./dashboard" className="nxl-link">
                                <span className="nxl-micon"><i className="feather-airplay"></i></span>
                                <span className="nxl-mtext">Anasayfa</span>
                            </a>
                        </li>
                        <li className="nxl-item">
                            <a href="./labels" className="nxl-link">
                                <span className="nxl-micon"><i className="feather-tag"></i></span>
                                <span className="nxl-mtext">Etiketler</span>
                            </a>
                        </li>
                        <li className="nxl-item">
                            <a href="./service-labels" className="nxl-link">
                                <span className="nxl-micon"><i className="feather-bookmark"></i></span>
                                <span className="nxl-mtext">Hizmet Etiketleri</span>
                            </a>
                        </li>
                        <li className="nxl-item">
                            <a href="./ads" className="nxl-link">
                                <span className="nxl-micon"><i className="feather-file-text"></i></span>
                                <span className="nxl-mtext">Meta Reklamları</span>
                            </a>
                        </li>
                        <li className="nxl-item">
                            <a href="./forms" className="nxl-link">
                                <span className="nxl-micon"><i className="feather-clipboard"></i></span>
                                <span className="nxl-mtext">Formlar</span>
                            </a>
                        </li>
                        <li className="nxl-item">
                            <a href="./services" className="nxl-link">
                                <span className="nxl-micon"><i className="feather-grid"></i></span>
                                <span className="nxl-mtext">Hizmetler</span>
                            </a>
                        </li>
                        <li className="nxl-item">
                            <a href="./reports" className="nxl-link">
                                <span className="nxl-micon"><i className="feather-flag"></i></span>
                                <span className="nxl-mtext">Rapor Oluştur</span>
                            </a>
                        </li>
                        <li className="nxl-item">
                            <a href="./offer-report" className="nxl-link">
                                <span className="nxl-micon"><i className="feather-file"></i></span>
                                <span className="nxl-mtext">Teklif Raporu</span>
                            </a>
                        </li>
                        <li className="nxl-item">
                            <a href="./create-customer" className="nxl-link">
                                <span className="nxl-micon"><i className="feather-user-plus"></i></span>
                                <span className="nxl-mtext">Manuel Müşteri Ekle</span>
                            </a>
                        </li>

                        {/* Mesajlaşma Modülleri */}
                        {(waActive || tgActive) && (
                            <li className="nxl-item nxl-caption" style={{ marginTop: '8px' }}>
                                <label>Mesajlaşma</label>
                            </li>
                        )}

                        {waActive && (
                            <li className="nxl-item">
                                <a href="./whatsapp-inbox" className="nxl-link">
                                    <span className="nxl-micon"><i className="bi bi-whatsapp" style={{ color: '#25D366' }}></i></span>
                                    <span className="nxl-mtext">WhatsApp Gelen Kutusu</span>
                                </a>
                            </li>
                        )}

                        {tgActive && (
                            <li className="nxl-item">
                                <a href="./telegram-inbox" className="nxl-link">
                                    <span className="nxl-micon"><i className="bi bi-telegram" style={{ color: '#0088cc' }}></i></span>
                                    <span className="nxl-mtext">Telegram Gelen Kutusu</span>
                                </a>
                            </li>
                        )}

                        {/* Sistem */}
                        <li className="nxl-item nxl-caption" style={{ marginTop: '8px' }}>
                            <label>Sistem</label>
                        </li>
                        <li className="nxl-item">
                            <a href="./settings" className="nxl-link">
                                <span className="nxl-micon"><i className="feather-settings"></i></span>
                                <span className="nxl-mtext">Ayarlar</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Menu;
